import { postRequest } from 'features/common'
import { User } from 'features/users'
import settings from 'settings'
import {
  DatasetIdProviderMetric,
  GeocodeMetric,
  QuotaEventMetric,
  MetricEvent,
  OnboardingItemMetric,
  AnalysisCreatedEvent,
  EnrichCreatedEventMetric,
  DataSourceAddedMetric
} from '../types'
import { getClient } from 'features/common/utils/clientParameter'
import { isPublicMapUrl } from 'features/builder/paths'

export enum MetricEventType { // TODO VVG: avoid using Type suffix on enums & consider moving to types (models)
  OpenHomePage = 'OpenHomePage',
  MapsListed = 'MapsListed',
  AiAgentsListed = 'AiAgentsListed',
  MapSelectedForAIAgentCreation = 'MapSelectedForAIAgentCreation',
  OpenBuilderMap = 'OpenBuilderMap',
  OpenDO = 'OpenDO',
  OpenDE = 'OpenDE',
  OpenConnections = 'OpenConnections',
  OpenApplications = 'OpenApplications',
  OpenSettings = 'OpenSettings',
  OpenDevelopers = 'OpenDevelopers',
  OpenAPIAccessTokens = 'OpenAPIAccessTokens',
  UserLogout = 'UserLogout',
  OnboardingOpened = 'OnboardingOpened',
  OnboardingCompleted = 'OnboardingCompleted',
  OnboardingSkipped = 'OnboardingSkipped',
  HelpSidebarOpened = 'HelpSidebarOpened',
  HelpSidebarBlockClick = 'HelpSidebarBlockClick',
  HelpSidebarSearchQuery = 'HelpSidebarSearchQuery',
  SQLAnalysisCreated = 'SQLAnalysisCreated',
  DOEnrichmentCreated = 'DOEnrichmentCreated',
  TableUsedDetails = 'TableUsedDetails',
  ResourceDeleted = 'ResourceDeleted',
  OptimizeTableLaunched = 'OptimizeTableLaunched',
  BuilderCustomAggResolution = 'BuilderCustomAggResolution',
  BuilderDataExport = 'BuilderDataExport',
  BuilderQueryThisTable = 'BuilderQueryThisTable',
  BuilderRefreshDataSource = 'BuilderRefreshDataSource',
  BuilderMaskCreated = 'BuilderMaskCreated',
  BuilderURLParameterUsed = 'BuilderURLParameterUsed',
  SQLParameterCreated = 'SQLParameterCreated',
  SQLParameterUsed = 'SQLParameterUsed',
  MapDescriptionCreated = 'MapDescriptionCreated',
  MapDescriptionUsed = 'MapDescriptionUsed',
  MapUpdatesPublished = 'MapUpdatesPublished',
  MapGetCoordinates = 'MapGetCoordinates',
  MapCopyCoordinates = 'MapCopyCoordinates',
  MeasureToolUsed = 'MeasureToolUsed',
  HexColorColumnStyled = 'HexColorColumnStyled',
  OpenWorkflow = 'OpenWorkflow',
  WorkflowsListed = 'WorkflowsListed',
  WorkflowRun = 'WorkflowRun',
  WorkflowExecutionComplete = 'WorkflowExecutionComplete',
  WorkflowMapCreated = 'WorkflowMapCreated',
  WorkflowsResultCopied = 'WorkflowsResultCopied',
  WorkflowsResultPaginationNavigationAction = 'WorkflowsResultPaginationNavigationAction',
  WorkflowsResultPaginationLengthChanged = 'WorkflowsResultPaginationLengthChanged',
  WorkflowsSQLExported = 'WorkflowsSQLExported',
  WorkflowsAPIEnabled = 'WorkflowsAPIEnabled',
  WorkflowsAPIDisabled = 'WorkflowsAPIDisabled',
  WorkflowsMcpToolEnabled = 'WorkflowsMcpToolEnabled',
  WorkflowsMcpToolDisabled = 'WorkflowsMcpToolDisabled',
  WorkflowsVariableAdded = 'WorkflowsVariableAdded',
  WorkflowsVariableUsed = 'WorkflowsVariableUsed',
  WorkflowsTemplateExplored = 'WorkflowsTemplateExplored',
  WorkflowTemplateCreated = 'WorkflowTemplateCreated',
  DataExplorerMapCreated = 'DataExplorerMapCreated',
  DataExplorerWorkflowCreated = 'DataExplorerWorkflowCreated',
  BuilderReportDownload = 'BuilderReportDownload',
  InviteUsersMainMenuClicked = 'InviteUsersMainMenuClicked',
  CopyMapLink = 'CopyMapLink',
  CopyEmbedCode = 'CopyEmbedCode',
  CopyMapId = 'CopyMapId',
  CopyMapToken = 'CopyMapToken',
  MapPublishUpdate = 'MapPublishUpdate',
  MapPreviewMode = 'MapPreviewMode',
  MapEditMode = 'MapEditMode',
  WorkflowsFileLoaded = 'WorkflowsFileLoaded',
  WorkflowsFileDeleted = 'WorkflowsFileDeleted',
  LayerTypeChanged = 'LayerTypeChanged',
  LayerAggregateByGeometry = 'LayerAggregateByGeometry',
  ZoomToLayer = 'ZoomToLayer',
  ShowOnlyThisLayer = 'ShowOnlyThis',
  WorkflowsExtensionInstalled = 'WorkflowsExtensionInstalled',
  WorkflowsExtensionUninstalled = 'WorkflowsExtensionUninstalled',
  WorkflowsExtensionFailed = 'WorkflowsExtensionFailed',
  SpatialColumnTypeDefined = 'SpatialColumnTypeDefined',
  TableWidgetInteraction = 'TableWidgetInteraction',
  ChangeDatasource = 'ChangeDatasource',
  LegendVisibilityChanged = 'LegendVisibilityChanged',
  LayerMapListStatusChanged = 'LayerMapListStatusChanged',
  BuilderCommentCreated = 'BuilderCommentCreated',
  BuilderCommentReplyCreated = 'BuilderCommentReplyCreated',
  BuilderCommentResolved = 'BuilderCommentResolved',
  BuilderCommentReopened = 'BuilderCommentReopened',
  BuilderCommentEdited = 'BuilderCommentEdited',
  BuilderCommentReplyEdited = 'BuilderCommentReplyEdited',
  BuilderCommentDeleted = 'BuilderCommentDeleted',
  BuilderCommentReplyDeleted = 'BuilderCommentReplyDeleted',
  BuilderCommentsMarkAllAsRead = 'BuilderCommentsMarkAllAsRead',
  BuilderCommentsUnsplit = 'BuilderCommentsUnsplit',
  DataSourceAdded = 'DataSourceAdded',
  ImportDropFileLoaded = 'ImportDropFileLoaded',
  CrossFilteringWidgetSettingsChanged = 'CrossFilteringWidgetSettingsChanged',
  WidgetFilteringInteraction = 'WidgetFilteringInteraction',
  WidgetAggregationUsed = 'WidgetAggregationUsed',
  BuilderWidgetOrderBy = 'BuilderWidgetOrderBy',
  SettingsCartoAIEnabled = 'SettingsCartoAIEnabled',
  SettingsCartoAIDisabled = 'SettingsCartoAIDisabled',
  CustomAIModelAdded = 'CustomAIModelAdded',
  CustomAIModelUpdated = 'CustomAIModelUpdated',
  CustomAIModelRemoved = 'CustomAIModelRemoved',
  AIAgentCreated = 'AIAgentCreated',
  AIAgentDeleted = 'AIAgentDeleted',
  AIAgentConfigurationChanged = 'AIAgentConfigurationChanged',
  AIAgentConversationStarted = 'AIAgentConversationStarted',
  AIAgentConversationDeleted = 'AIAgentConversationDeleted',
  AIAgentResponseStopped = 'AIAgentResponseStopped',
  AIAgentFeedback = 'AIAgentFeedback',
  DODatasetRequest = 'DODatasetRequest',
  SearchConnections = 'SearchConnections',
  ConnectionBookmarkFilterApplied = 'ConnectionBookmarkFilterApplied'
}

const { workspaceApiUrl } = settings

const metricsEndpointUrl = `${workspaceApiUrl}/events`

export const createDOMapEvent = createEvent<DatasetIdProviderMetric>('DOMapCreated')
export const createTilesetEvent = createEvent<DatasetIdProviderMetric>('TilesetCreated')
export const accessInEvent = createEvent<DatasetIdProviderMetric>('DOAccessIn')
export const accessInRequestEvent = createEvent<DatasetIdProviderMetric>('DOAccessInRequest')
export const launchGeocodeTableEvent = createEvent<GeocodeMetric>('GeocodeLaunched')
export const postQuotaEventRequest = createEvent<QuotaEventMetric>('QuotaUXTriggered')
export const onboardingItemCheckedEvent = createEvent<OnboardingItemMetric>('OnboardingItemChecked')
export const featuredUpdateOpenedEvent = createEvent<OnboardingItemMetric>('FeaturedUpdateOpened')
export const demoMapDuplicatedEvent = createEvent<OnboardingItemMetric>('DemoMapDuplicated')
export const demoWorkflowDuplicatedEvent = createEvent<OnboardingItemMetric>('DemoWorkflowDuplicated')
export const analysisCreatedEvent = createEvent<AnalysisCreatedEvent>('SQLAnalysisCreated')
export const enrichmentCreatedEvent = createEvent<EnrichCreatedEventMetric>('DOEnrichmentCreated')
export const dataSourceAddedEvent = createEvent<DataSourceAddedMetric>('DataSourceAdded')

export const createMetricEvent = (eventType: MetricEventType) => {
  return createEvent(eventType)
}

function createEvent<T>(eventType: string) {
  return async (metricEvent: MetricEvent<T>) => {
    if (isPublicMapUrl()) return

    const { user, ...extraPayload } = metricEvent
    await postMetricEvent(eventType as MetricEventType, user, extraPayload)
  }
}

export async function postMetricEvent(eventType: MetricEventType, user?: User, extraPayload?: Record<string, unknown>) {
  const payload = {
    accountId: user?.user_metadata.account_id,
    userId: user?.user_id,
    client: getClient(),
    ...extraPayload
  }

  const requestData = {
    event_type: eventType,
    payload,
    timestamp: new Date()
  }
  await postRequest(metricsEndpointUrl, requestData)
}
